import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { DialTarget } from 'src/app/store/samwin/next-dial-target/next-dial-target.state';
import { IPeerInfo } from 'src/app/store/samwin/samwin-lines/samwin-lines.state';

@Pipe({
   name: 'dialTargetToPeerInfo',
})
export class DialTargetToPeerInfoPipe implements PipeTransform {
   constructor() {}

   transform(dialTarget: DialTarget): IPeerInfo {
      if (_.isNil(dialTarget)) {
         return null;
      }
      return {
         peerId: dialTarget.number,
         peerName: dialTarget?.name,
      };
   }
}
